import React from 'react';
import { Route, Routes } from "react-router-dom";
import SendOutCreateScreen from "screens/App/CRM/SendOut/SendOutCreateScreen";
import SendOutDetailScreen from "screens/App/CRM/SendOut/SendOutDetailScreen";
import SendOutEditScreen from "screens/App/CRM/SendOut/SendOutEditScreen";
import SendOutListScreen from "screens/App/CRM/SendOut/SendOutListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const SendOutRouter = () => {
    return (
        <Routes>
            <Route path="create" element={<SendOutCreateScreen />} />
            <Route path="list" element={<SendOutListScreen />} />
            <Route path=":id/detail" element={<SendOutDetailScreen />} />
            <Route path=":id/edit" element={<SendOutEditScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
        </Routes>
    );
};

export default  SendOutRouter;
    
